import { render, staticRenderFns } from "./ModalCookie.vue?vue&type=template&id=338978c1&scoped=true"
import script from "./ModalCookie.vue?vue&type=script&lang=js"
export * from "./ModalCookie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338978c1",
  null
  
)

export default component.exports